export function currencyFlag(code:string):string {
  const exceptions:Record<string,string>={EUR:"EU",XAF:"CM",XOF:"SN",XCD:"AG",XPF:"PF",XCG:"CW",ANG:"CW",GBP:"GB",CHF:"CH"};
  if (code.startsWith("X") && !exceptions[code]) return "🌐";
  const country=exceptions[code]||code.slice(0,2);
  return /^[A-Z]{2}$/.test(country)?String.fromCodePoint(...[...country].map(letter=>127397+letter.charCodeAt(0))):"🌐";
}
